import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { backgroundColor, errorColorPalette } = params;
  const fallback = {
    rule: 'input.errorMessage.light',
    params,
  };

  return increaseColorPointByRatio(
    {
      targetColor: errorColorPalette[50],
      targetColorPalette: errorColorPalette,
      backgroundColor,
      condition: (ratio) => ratio >= 3,
      fallback,
    },
    '50'
  );
};

export default light;
